import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localeDeCh from '@angular/common/locales/de-CH'
import { ApplicationConfig, inject, provideAppInitializer } from '@angular/core';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { AppInitService } from '@app/app-init.service';
import { routes } from '@app/app.routes';
import { accessTokenInterceptor } from '@app/core/auth/access-token.interceptor';
import { globalHttpInterceptor } from '@app/core/auth/global-http.interceptor';
import { languageInterceptor } from '@app/core/i18n/language.interceptor';
import { CustomRouteReuseStrategy } from '@app/core/routing/custom-route-reuse-strategy';
import { TabComponent } from '@app/shared/tabs/tab.component';
import { TabsComponent } from '@app/shared/tabs/tabs.component';
import { provideLoadingBarRouter } from '@ngx-loading-bar/router';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideDynamicHooks } from 'ngx-dynamic-hooks';

registerLocaleData(localeDeCh, 'de-CH');

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([
        accessTokenInterceptor,
        languageInterceptor,
        globalHttpInterceptor
      ])
    ),
    provideLoadingBarRouter(),
    provideTranslateService(),
    provideTranslateHttpLoader(),
    provideDynamicHooks({
      parsers: [
        {component: TabsComponent, allowSelfClosing: false},
        {component: TabComponent}
      ]
    }),
    AppInitService,
    provideAppInitializer(() => inject(AppInitService).init()),
    {provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy},
  ]
}
